import { doctorList, queryDoctorDept, doctorInfo, doctorAdd, doctorEdit, getPreRegisPrice, getDoctorSchedulingList,getHelpDoctorList ,markHelpFlag } from '@/api/doctor'

class doctorDTO {
    /**
     * 获取医生列表
     */
    static getDoctorList(params) {
        return new Promise((resolve, reject) => {
            doctorList(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 查询医馆医生
     */
    static queryDoctorDept(params) {
        return new Promise((resolve, reject) => {
            queryDoctorDept(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 获取医生详情
     */
    static getDoctorInfo(doctorId) {
        return new Promise((resolve, reject) => {
            doctorInfo(doctorId).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 新增医生
     */
    static doctorAdd(params) {
        return new Promise((resolve, reject) => {
            doctorAdd(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 修改医生信息
     */
    static doctorEdit(params) {
        return new Promise((resolve, reject) => {
            doctorEdit(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 获取医生挂号费
     */
    static getPreRegisPrice(params){
        return new Promise((resolve, reject) => {
            getPreRegisPrice(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 获取医生挂号费
     */
    static getDoctorSchedulingList(params){
        return new Promise((resolve, reject) => {
            getDoctorSchedulingList(params).then(res => {
                resolve(res)
            })
        })
    }
 /**
     * 获取医助助理医生
     */
    static getHelpDoctorListDTO(params){
        return new Promise((resolve, reject) => {
            getHelpDoctorList(params).then(res => {
                resolve(res)
            })
        })
    }
    /**
     * 标记医助医生
     */
    static markDoctorDTO(params){
        return new Promise((resolve, reject) => {
            markHelpFlag(params).then(res => {
                resolve(res)
            })
        })
    }
}

export {doctorDTO}
